// extracted by mini-css-extract-plugin
export default {"scrollContainerStyles":"burger-ingredients_scrollContainerStyles__XcszT","tabHeader":"burger-ingredients_tabHeader__VXGlT","tabsWrapper":"burger-ingredients_tabsWrapper__5t5uL"};